import React from "react";
import { ErrorBoundary } from "./ErrorBoundary";
import { FallbackUI } from "./FallbackUI";
import { useLocation } from "react-router-dom";

interface RouteErrorBoundaryProps {
  children: React.ReactNode;
  moduleName?: string;
}

export const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = ({
  children,
  moduleName,
}) => {
  const location = useLocation();

  return (
    <ErrorBoundary
      key={moduleName || location.pathname}
      fallback={({ error, resetErrorBoundary }) => (
        <FallbackUI
          error={error}
          resetErrorBoundary={resetErrorBoundary}
          isGlobal={false}
        />
      )}
      onError={(error, errorInfo) => {
        // Placeholder for route-level logging
        console.error(
          `Route Error Caught in module [${moduleName || "Unknown"}]:`,
          error,
          errorInfo,
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
